module.exports = __webpack_public_path__ + "static/process-160cf5aaec655b6aa097657358a5d022.svg";